module.exports = __webpack_public_path__ + "static/media/Screenshot_2-thumb.ec6da539.png";